const gqlDisplayName = user =>
  user
    ? (user.firstname &&
        user.lastname &&
        user.firstname + ' ' + user.lastname) ||
      '@' + user.username
    : 'someone'

const displayName = user =>
  user
    ? (user[':user/firstname'] &&
        user[':user/lastname'] &&
        user[':user/firstname'] + ' ' + user[':user/lastname']) ||
      '@' + user[':user/username']
    : 'someone'

const displayFirst = user => {
  return (
    user &&
    ((user[':user/firstname'] && user[':user/firstname']) ||
      user[':user/username'])
  )
}

const gqlDisplayFirst = user => {
  return user && (user.firstname || user.username)
}

const hasName = user => user[':user/firstname'] || user[':user/lastname']

const displayUsername = user => user[':user/username'] || user.username

const displayNameExtended = user =>
  hasName(user)
    ? `${displayName(user)} (@${displayUsername(user)})`
    : displayName(user)

const hasProfileName = user => user.firstname || user.lastname

const gqlDisplayNameExtended = user =>
  hasProfileName(user)
    ? `${gqlDisplayName(user)} (@${displayUsername(user)})`
    : gqlDisplayName(user)

module.exports = {
  displayName,
  gqlDisplayName,
  displayFirst,
  gqlDisplayFirst,
  displayNameExtended,
  gqlDisplayNameExtended
}
